<template>
  <div :id="filtro.filtro" class="container-multi-select">
    <div @click="toogleSelect" class="container-toogle-select" :style="styledFocusSelect(selectActive, ['border-color', 'color'])">
      <b>{{ label }}:</b>
      <span class="selecione" v-if="itemsSelecionados.length < 1" :style="styledFocusSelect(selectActive, ['color'])">Selecione</span>
      <span class="items-selecionados" v-for="(item, index) in itemsSelecionados" :key="item.id">
        {{ item.name }}<span v-if="index < itemsSelecionados.length - 1">,</span>
      </span>
      <SVGIcon iconName="icon-close" :size="8" @click.stop="onExcluded" />
    </div>
    <div class="select-adicionar-campos" v-if="selectActive">
      <div class="container-search">
        <i class="fa fa-search icn-search"></i>
        <input
          type="text"
          ref="inputSearch"
          class="ipt-search"
          placeholder="Busque pelo campo"
          v-model="search"
        />
      </div>
      <div class="container-items">
        <div v-for="campo in camposFiltrados" :key="campo.id" class="item" @click="handleClickElementToChecked(campo.id)">
          <input 
            type="checkbox"
            class="custom-checkbox"
            :name="campo.name"
            :id="campo.id"
            :value="campo.id"
            :checked="itemsTemporariosIds.has(String(campo.id))"
            @click.stop="handleClickElementToChecked(campo.id)"
            :disabled="campo.default"
          />
          <span>{{ campo.name }}</span>
        </div>
      </div>
      <div class="container-button-aplicar">
        <button @click="salvar" class="btn btn-maino">Salvar</button>
      </div>
    </div>
  </div>
</template>
<script>
import SelectAdicionarCampos from '../components/SelectAdicionarCampos.vue';
import SVGIcon from '../../SvgIcon.vue';
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    campos: {
      type: Array,
      required: true
    },
    filtro: {
      type: Object,
      required: true
    },
    filtro_id: {
      type: String,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  emits: ['atualizar'],
  data() {
    return {
      selectActive: false,
      itemsSelecionados: [],
      itemsTemporarios: [],
      search: '',
    }
  },
  computed: {
    camposFiltrados() {
      return this.campos.filter(campo => {
         const name = this.$removeAccents(campo.name.toLowerCase())
         const search = this.$removeAccents(this.search.toLowerCase())
         return name.includes(search)
      })
    },
    itemsTemporariosIds() {
      return new Set(this.itemsTemporarios.map(item => String(item.id)));
    }
  },
  components: {
    SelectAdicionarCampos,
    SVGIcon,
  },
  methods: {
    toogleSelect() {
      this.selectActive = !this.selectActive;
      
      if (this.selectActive) {
        this.itemsTemporarios = [...this.itemsSelecionados];
        this.$nextTick(() => {
          this.$refs.inputSearch.focus();
        });
      }
    },
    salvar() {
      this.itemsSelecionados = [...this.itemsTemporarios];
      const selectedIds = this.itemsSelecionados.map(item => item.id);
      this.$emit('atualizar', selectedIds);
      this.selectActive = false;
    },
    onExcluded() {
      this.$store.commit('removeFiltro', this.filtro_id);
      this.$removeFiltroDaURL(this.filtro_id, this.path);
      this.$filtroDb.removeFiltro(this.path, this.filtro_id)
        .catch(error => exibe_erro('Erro ao remover preferencia de filtro'));
    },
    styledFocusSelect(selectActive, styles) {
      if(!selectActive) return;

      let stylesTotal = [];
      styles.map(style => {
        stylesTotal.push(`${style}: var(--maino-blue-hover);`);
      })
      return stylesTotal.join(' ');
    },
    handleClickElementToChecked(id) {
      const itemIndex = this.itemsTemporarios.findIndex(item => String(item.id) === String(id));
      
      if (itemIndex >= 0) {
        this.itemsTemporarios.splice(itemIndex, 1);
      } else {
        const campo = this.campos.find(c => String(c.id) === String(id));
        if (!campo) return;
        
        this.itemsTemporarios = [ ...this.itemsTemporarios, { id: campo.id, name: campo.name } ];
      }
    }
  },
  mounted() {
    const store = this.$store.state.filtroAplicados;
    if (store[this.filtro.filtro]) {
      const items = store[this.filtro.filtro].split(',').map(id => id.trim());
      this.itemsSelecionados = this.campos.filter(campo =>
        items.includes(String(campo.id))
      ).map(campo => ({
        id: campo.id,
        name: campo.name
      }));
    }

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.container-multi-select')) {
        this.selectActive = false;
      }
    });
  }
}
</script>

